import { useEffect, useRef, useState } from "react";

export const LazyMap = ({ query, title }) => {
    const ref = useRef(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setShow(true);
                    obs.disconnect();
                }
            },
            { rootMargin: "200px" },
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            data-testid="project-map"
            className="h-full min-h-[340px] w-full bg-stone"
        >
            {show && (
                <iframe
                    title={title}
                    src={`https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`}
                    className="h-full min-h-[340px] w-full"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            )}
        </div>
    );
};
